import { getElementTypesById } from "core-integration/src/store/element-types/reducers";
import { useSelector } from "react-redux";
import { usePlosTranslations } from "../../contexts/PlosTranslationsContext";
import DreamTeam from "../../img/icons/dreamteam.svg?react";
import { visuallyHidden } from "../../styles/utils.css";
import { UnstyledRACButton } from "../buttons/UnstyledRACButton";
import { CaptainIcon } from "../CaptainIcon";
import ElementShirt from "../ElementShirt";
import { PlayerNotesIcon } from "../playerNotes/PlayerNotesIcon";
import { ElementIcon } from "../tooltips/ElementIcon";
import {
  elementDataContainer,
  elementIconInTable,
  elementInTable,
  elementInTableButton,
  elementInTableWrapper,
  elementWebName,
  iconContainer,
  iconWrapper,
  info,
} from "./elementInTable.css";
import { ElementInTableProps } from "./types";

const ElementInTable = ({
  element,
  actionMe,
  team,
  chipName,
  children,
  pick,
  renderDreamTeam,
}: ElementInTableProps) => {
  const {
    captain: captainText,
    viceCaptain: viceCaptainText,
    dreamTeam,
  } = usePlosTranslations();
  const elementType = useSelector(getElementTypesById)[element?.element_type];

  const showCaptain = pick?.is_captain || pick?.is_vice_captain;

  let dreamTeamContent = null;
  if (typeof renderDreamTeam === "function" && pick) {
    dreamTeamContent = renderDreamTeam(pick);
  } else if (renderDreamTeam === true) {
    dreamTeamContent = (
      <ElementIcon label={dreamTeam}>
        <DreamTeam aria-hidden className={elementIconInTable} />
      </ElementIcon>
    );
  }

  return (
    <div className={elementInTableWrapper}>
      <UnstyledRACButton onPress={actionMe} className={elementInTableButton}>
        <div className={elementInTable}>
          {children}
          <ElementShirt
            elementId={element.id}
            teamId={team.id}
            alt=""
            sizes="25px"
          />
          <span className={visuallyHidden}>
            {element.web_name}, {team.name}
          </span>
          <div className={elementDataContainer} aria-hidden="true">
            <span className={elementWebName}>{element.web_name}</span>
            <span className={info}>
              <span>{team.name}</span>
              <span>{elementType.singular_name_short}</span>
            </span>
          </div>
        </div>
      </UnstyledRACButton>
      <div className={iconWrapper}>
        <div className={iconContainer}>
          <div className={elementIconInTable}>
            <PlayerNotesIcon element={element} />
          </div>
          {dreamTeamContent && (
            <div className={elementIconInTable}>{dreamTeamContent}</div>
          )}
          {showCaptain && (
            <div className={elementIconInTable}>
              <ElementIcon
                label={pick.is_captain ? captainText : viceCaptainText}
              >
                <CaptainIcon chipName={chipName} pick={pick} aria-hidden />
              </ElementIcon>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ElementInTable;
